import { jsx } from "panel";
import { selx } from "clsx";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import styles from "./index.module.styl";
export function template() {
  const { t } = this.getContext(`i18n`);
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.mpQuerySamplingCta) }, /* @__PURE__ */ jsx("div", { sel: ".mp-query-sampling-cta-title" }, t(`sampling.query-sampling.cta-header`)), /* @__PURE__ */ jsx(ButtonEl, { on: { click: this.handleEnableQuerySampling }, attrs: { theme: ButtonTheme.Secondary, icon: `sampling` } }, t(`sampling.query-sampling.cta-header`)));
}
